import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils";
/**
 * StatItemList - Shared item list rendering used by both StatListCard and StatListModal
 */ function StatItemList({ items, emptyMessage }) {
    if (items.length === 0) {
        return /*#__PURE__*/ _jsx("p", {
            className: "text-sm text-muted-foreground py-4 text-center",
            children: emptyMessage
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        children: items.map((item, index)=>/*#__PURE__*/ _jsxs("li", {
                className: cn("flex items-center justify-between py-3", index !== items.length - 1 && "border-b"),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-sm font-medium",
                        children: item.label
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "text-sm text-muted-foreground",
                        children: [
                            item.value,
                            item.suffix && ` ${item.suffix}`
                        ]
                    })
                ]
            }, item.id))
    });
}
export { StatItemList };

//# sourceMappingURL=stat-item-list.js.map